var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"text-center mb-5 text-primary"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$route.name))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }